import "../bootstrap.min.css";
import "../style.css";
import "../responsive.css";
import "../custom.css";
import { useContext } from "react";
import PortalContext from "../../Pages/PortalContext";

export default function WeightQuestion(props) {
  const { portal } = useContext(PortalContext);

  return (
    <>
      <div className="weight-wrap mt-3">
      <div
        className="weight-card"
        style={{
          background: "#f8f9fa",
          borderRadius: "8px",
          padding: "16px",
          border: "1px solid #cbcfd4ff",
        }}
      >
        <div
          className="service-title mb-1"
          style={{ color: portal.data.settings.colours.primary, fontWeight: 600 }}
        >
          {
            portal?.data?.settings?.weightQuestions?.[portal.step2.country]
              .labelPortalWeightQuestion
          }
        </div>

        <div className="service-body text-muted mb-3">
          {
            portal?.data?.settings?.weightQuestions?.[portal.step2.country]
              .labelPortalWeightQuestionHelpText
          }
        </div>

        <select
          onChange={(e) => props.setWeightQuestion(e.target.value)}
          id="weightQuestion"
          name="weightQuestion"
          required
          className="form-control"
          style={{ width: "100%" }}
        >
          <option value="">Select weight</option>
          {portal?.data?.settings?.weightQuestions?.[portal.step2.country].answers.map((a) => (
            <option value={a.optionValue} key={a.optionValue}>{a.optionName}</option>
          ))}
        </select>
      </div>
    </div>
    </>
  );
}
